import * as XLSX from 'xlsx';

/**
 * Reads and parses an Excel file into a 2D array
 * @param file - Excel file (.xlsx or .xls)
 * @returns Promise<string[][]> - 2D array where each row is an array of cell values
 */
export const readFile = (file: File): Promise<string[][]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = event.target?.result as string;

        // Parse Excel
        const workbook = XLSX.read(data, { type: 'binary' });

        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          reject(new Error('Excel file is empty or has no sheets'));
          return;
        }

        // Check for multiple sheets
        if (workbook.SheetNames.length > 1) {
          reject(
            new Error(
              'Excel file contains multiple sheets. Please ensure the file has only one sheet with the required data.'
            )
          );
          return;
        }

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const parsedData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
        }) as string[][];

        resolve(parsedData);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = reject;

    // Excel files are binary format (ZIP archives)
    reader.readAsBinaryString(file);
  });
};
